export const GET_SUPERVISION_SUMMARY = 'GET_SUPERVISION_SUMMARY';
export const GET_SUPERVISION_SUMMARY_SUCCESS = 'GET_SUPERVISION_SUMMARY_SUCCESS';
